import {createSlice} from '@reduxjs/toolkit';
import {getCustomerBranding} from './actions';
import {CustomerBrandingState} from './types';

const initialState: CustomerBrandingState = {
  loadingStatus: 'NotLoaded',
  branding: {
    title: '',
    bannerUrl: '',
    logoUrl: '',
  },
};

const slice = createSlice({
  name: 'customerBranding',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerBranding.pending, (state) => {
        state.loadingStatus = 'Loading';
      })
      .addCase(getCustomerBranding.fulfilled, (state, action) => {
        const customerBranding = action.payload;

        state.branding = customerBranding;
        state.loadingStatus = 'Loaded';
      })
      .addCase(getCustomerBranding.rejected, (state) => {
        state.loadingStatus = 'Failed';
      });
  },
});

export const {reducer: customerBrandingReducer} = slice;
